import { COLOR_VARIANTS, Tooltip, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import Styled from './Time.styled';
import { format as formatDate } from 'date-fns';

// utils
import { getFormattedTime } from '@/utils/date.utils';
import _isUndefined from 'lodash/isUndefined';
import { useTranslation } from 'react-i18next';

// hooks
import { useStore } from '@/contexts/StoreContext';
import useStateOfUI from '@/hooks/useStateOfUI';
import { Store } from '@/stores';

export type TimeProps = {
  time: string;
  arrivalFlag?: string;
  isDeparture?: boolean;
  arrivalDate?: Date;
  testId: string;
  store?: Store;
};

function Time({ time, arrivalFlag, isDeparture, arrivalDate, testId, store }: TimeProps): JSX.Element {
  const flightStore = useStore();
  const { is12HoursTimeFormat } = useStateOfUI(store || flightStore);
  const { t } = useTranslation();

  const [timeFormatted, format] = getFormattedTime(new Date(time), Boolean(is12HoursTimeFormat));

  return (
    <Styled.TimeWrapper $isDeparture={isDeparture}>
      <Typography testId={testId} variant={TYPOGRAPHY_VARIANT.HEADING2} component="h2">
        {timeFormatted}
      </Typography>
      {(arrivalFlag || Boolean(is12HoursTimeFormat)) && (
        <Styled.TimeFormat $isAMFormat={Boolean(is12HoursTimeFormat)}>
          {!_isUndefined(arrivalFlag) && arrivalFlag !== 'undefined' && (
            <Tooltip
              title={
                <Styled.TimeTooltipContent>
                  <Typography variant={TYPOGRAPHY_VARIANT.BODY2} component="span" color={COLOR_VARIANTS.WHITE}>
                    {t('SearchResults.ArrivesOn')}
                  </Typography>
                  <Typography variant={TYPOGRAPHY_VARIANT.HEADING4SEMBLD} component="h4" color={COLOR_VARIANTS.WHITE}>
                    {formatDate(new Date(arrivalDate), 'eee, d MMM')}
                  </Typography>
                </Styled.TimeTooltipContent>
              }
              placement="top"
            >
              <Styled.ArrivalFlag>
                <Typography color={COLOR_VARIANTS.GREYCHATEAU} component="p" variant={TYPOGRAPHY_VARIANT.CAPTIONREG}>
                  {arrivalFlag}
                </Typography>
              </Styled.ArrivalFlag>
            </Tooltip>
          )}
          <Typography color={COLOR_VARIANTS.MINESHAFT} variant={TYPOGRAPHY_VARIANT.CAPTIONREG} component="p">
            {format}
          </Typography>
        </Styled.TimeFormat>
      )}
    </Styled.TimeWrapper>
  );
}

export default Time;
